export default "__VITE_ASSET__f559f09d__"